import { render, staticRenderFns } from "./SgkMossipHacziTalepEvrakForm.vue?vue&type=template&id=28ffdf14"
import script from "./SgkMossipHacziTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./SgkMossipHacziTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports